export default "__VITE_ASSET__BfZCq9nC__"